import { render, staticRenderFns } from "./AuthThird.vue?vue&type=template&id=01906566&"
import script from "./AuthThird.vue?vue&type=script&lang=js&"
export * from "./AuthThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports